import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Breadcrumb, Button } from "pepsico-ds";
import { useAuth } from "../../utils/auth/useAuth";
import { getUserClaims } from "../../utils/auth/unified-auth";
import { Row, Col } from "antd";
import { LoadingSpinner } from "pepsico-ds";
import Fastmarkets from '../../assets/Fastmarkets.svg'
import SBACCI from '../../assets/SBACCI.png'
import { FetchCommodityLandingAction } from "../../redux/action/RISIAction";
import { FetchSBACCIReportCountAction } from "../../redux/action/SBACCIAction";
import { FetchLandingPageAction } from "../../redux/action/LandingPageAction";
import { FetchMIL2Action } from "../../redux/action/CommodityPackagingAction";
import { call7DaysNpsLogic } from "../../utils/utils";
import { localStoreKeys } from "../../constants/localStoreKeys";
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import CommodityCard from "../../components/Cards/CommodityCard";

const PackagingOverview = () => {
    const navigate = useNavigate();
	const dispatch = useDispatch();
	const { category } = useParams();
	const { authState } = useAuth();
	const [userInfo, setUserInfo] = useState({});
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [isUserDataFetched, setIsUserDataFetched] = useState(false)
    
	const userData = useSelector((state) => state.getLandingPageReducer);
	const cardData = useSelector((state) => state.getCommodityLandingReducer);
	const sbacciCardData = useSelector((state) => state.getCommodityLandingSBACCIReportCountReducer);
	const miL2Data = useSelector((state) => state.getMIL2Reducer);

    const packagingCards = miL2Data?.cardDetail || [];
    const risiData = cardData?.risiData

    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && userData && userData.type === "SUCCESS_LANDING_PAGE_ACTION") {
            call7DaysNpsLogic(dispatch, userData)
            setIsDataLoading(true)
            dispatch(FetchCommodityLandingAction());
            dispatch(FetchSBACCIReportCountAction());
            dispatch(FetchMIL2Action(category, userData?.emailId));
        }
		
    }, [userData])
    
    useEffect(() => {
        return () => {
            dispatch({ 
                payload: "RESET_COMMODITY_MAIN_ACTION", 
                type: 'RESET_COMMODITY_MAIN_ACTION' 
            });
            dispatch({
                payload: "RESET_MI_L2_ACTION",
                type: 'RESET_MI_L2_ACTION'
            });
        };
    }, []);
    
    /* istanbul ignore next */
    useEffect(() => {
        if (cardData && cardData?.type === "SUCCESS_COMMODITY_MAIN_ACTION") {
            setIsDataLoading(false)
        }
    }, [cardData])

	
    useEffect(() => {
		async function fetchUserInfo() {
			const user = await getUserClaims();
			if (user) {
				setUserInfo(user);
				dispatch(FetchLandingPageAction(user));
				setIsUserDataFetched(true)
			}
		}
        setIsDataLoading(true)
		fetchUserInfo();
	}, []);
    
    return (
        <>
            {
					
                (isDataLoading || cardData?.type !== "SUCCESS_COMMODITY_MAIN_ACTION" || !miL2Data?.subCategory) ? 
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                    <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                </div>
                :
                <>
                    <Breadcrumb
                        breadcrumbs={[
                            {
                            label: 'Home',
                            onClick: function aFe(){navigate("/overview")}
                            },
                            {
                            label: 'Market Intelligence Hub',
                            // onClick: function aFe(){navigate("/overview/commodity")}
                            onClick: function aFe(){
                                dispatch(setKeyValue({ key: localStoreKeys.commodityL1RestoreSwitcher, value: true }));
                                navigate("/overview/mi")
                            }
                            },
                            {
                            label: miL2Data?.l1Category ,
                            onClick: function aFe(){navigate(`/overview/mi/${category}`)}
                            }
                        ]}
                        className="ph-breadcrumb"
                        style={{padding: '24px 24px 24px 0px', width: "100%"}}
                        homeIcon={{
                            icon: 'track_changes'
                        }}
                    />

                    <div className="commodity-detail-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "5px" }}>
                        <span>{miL2Data?.l1Category}</span> 
                    </div>
                    <div className="risi-title-info" style={{fontSize: "13px", whiteSpace: "normal"}}>
                        <span style={{fontWeight:"700", fontSize: "13px"}}>SUB-CATEGORIES:</span> {miL2Data?.subCategory}
                    </div>
                    <div className="risi-title-info" style={{fontSize: "13px"}}>
                        <span style={{fontWeight:"700", fontSize: "13px"}}>SOURCES:</span> {miL2Data?.sources}
                    </div>
                    <div className="risi-title-info" style={{fontSize: "13px"}}>
                        <span style={{fontWeight:"700", fontSize: "13px"}}>CAPABILITIES:</span> {miL2Data?.capabilities}
                    </div>

                    
                    <div className="commodity-detail-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "24px 0px", fontSize: "18px", lineHeight:"56px" }}>
                        <span>Sub-categories</span> 
                    </div>
                {/* {
                    card.name == "Packaging" ? ( */}
                        {/* <>
                            <Row gutter={[20, 20]}>
                                <Col xs={15} sm={15} md={12} lg={12} xl={8}>
                                    <CommodityCard card= {{
                                        name:"Corrugated", 
                                        description: "Total number of Price Indices available: ", 
                                        image: Fastmarkets, 
                                        subDescription: null, // "Powered By FastMarkets" , 
                                        buttonText: "Launch",
                                        url:"/overview/commodity/packaging-indices/risi-page",
                                        data: risiData
                                    }}
                                    subCategories={null}
                                    sources={"FASTMARKETS (RISI)"}
                                    capabilities={"Commodity Prices, Forecasts"}
                                    />
                                </Col>                    
                                <Col xs={15} sm={15} md={12} lg={12} xl={8}>
                                    <CommodityCard card= {{
                                        name:"PET Resin", 
                                        description: "Total number of Market Reports available: ", 
                                        image: SBACCI, 
                                        subDescription: null, // "Powered By SBACCI & CMA" , 
                                        buttonText: "Launch",
                                        url:"/overview/commodity/packaging-indices/sba-cci",
                                        data: sbacciCardData
                                    }}
                                    color="#821D04"
                                    subCategories={null}
                                    sources={"SBACCI | CMA | Woodmac"}
                                    capabilities={"Commodity Prices, Forecasts, Market Reports"}/>
                                </Col>
                            </Row>
                        </> */}
                    {/* ) : ( */}
                        <>
                            <Row gutter={[20, 20]}>
                                {packagingCards.map((card, index) => (
                                    <Col key={index} xs={15} sm={15} md={12} lg={12} xl={8}>
                                        <CommodityCard
                                            card={{
                                                name: card.name,
                                                description: card.description,
                                                image: card.image,
                                                subDescription: card.subDescription,
                                                buttonText: card.buttonText,
                                                url: card.url,
                                                dataAsOn: card.dataAsOn,
                                                refreshFrequency: card.refreshFrequency,
                                                isDirects: card.isDirects,
                                                count: card.count,
                                                isFavorite: card.isFavorite,
                                                l0Category: card.l0Category,
                                            }}
                                            color={card.color}
                                            subCategories={card.subCategories}
                                            sources={card.sources}
                                            capabilities={card.capabilities}
                                            isL2Page={true}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        </>
                    {/* )
                } */}

                
                
                
                </>
            }
        </>
    );
};

export default PackagingOverview;
